import { render, staticRenderFns } from "./task-note.vue?vue&type=template&id=3f8b8def&"
import script from "./task-note.vue?vue&type=script&lang=js&"
export * from "./task-note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f8b8def')) {
      api.createRecord('3f8b8def', component.options)
    } else {
      api.reload('3f8b8def', component.options)
    }
    module.hot.accept("./task-note.vue?vue&type=template&id=3f8b8def&", function () {
      api.rerender('3f8b8def', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/task-note.vue"
export default component.exports